import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWidgetRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-widget',
	path: '/jira/servicedesk/projects/:projectKey/settings/widget',
	exact: true,
};
